import { getDatadogConfig, getVyEnv } from "./utils";

export const initDatadogRum = () => {
  const vyEnv = getVyEnv();

  // Skip in local development
  if (["dev", "local"].includes(vyEnv)) {
    console.log(`Skipping Datadog Analytics initialization in env: ${vyEnv}`);
    return;
  }
  const datadogConfig = getDatadogConfig();
  if (!datadogConfig) {
    console.warn("Datadog Analytics config not found, skipping initialization");
    return;
  }

  // Only import RUM for analytics
  import("@datadog/browser-rum")
    .then(({ datadogRum }) => {
      datadogRum.init({
        site: "datadoghq.eu",
        applicationId: datadogConfig.applicationId,
        clientToken: datadogConfig.clientToken,
        service: datadogConfig.service,
        env: vyEnv,
        sessionSampleRate: 100,
        version: import.meta.env.VERSION,

        sessionReplaySampleRate: 100, // Explicitly enable

        // Product Analytics tracking
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "allow",

        // Privacy settings
        enablePrivacyForActionName: true,
        actionNameAttribute: "data-dd-action-name",
        storeContextsAcrossPages: false,

        traceSampleRate: 100,
        allowedTracingUrls: [
          /^https:\/\/[^/]+\.vydev\.io/,
          /^https:\/\/[^/]+\.vy\.no/,
          /https?:\/\/localhost:\d{4}\/topas/,
        ], // Don't trace external requests unless needed
      });

      console.log("Datadog RUM initialized.");
    })
    .catch((error) => {
      console.warn("Failed to initialize Datadog Analytics:", error);
    });
};
